<template>
  <span
      :class="['ui-badge', `ui-badge--${variant}`, { pill }]"
      :style="{ '--ui-font-size': fontSize + 'px' }"
  >
    <slot>{{ text }}</slot>
  </span>
</template>

<script>
export default {
  name: 'UIBadge',
  props: {
    text: { type: String, default: '' },
    /**
     * Variante visual do badge
     * @type {'info' | 'success' | 'warning' | 'danger' | 'secondary'}
     */
    variant: {
      type: String,
      default: 'info',
      validator: (v) => ['info', 'success', 'warning', 'danger', 'secondary'].includes(v)
    },
    pill: { type: Boolean, default: false },
    fontSize: { type: [String, Number], default: 12 },
  }
}
</script>

<style lang="scss" scoped>
@import '@src/design/ui-design/_variables.scss';

.ui-badge {
  @include badge-base();

  width: fit-content;
  font-size: var(--ui-font-size);
  font-weight: $font-weight-600;

  &.pill {
    border-radius: 500px;
  }

  &--info {
    background: $blue-50;
    color:      $blue-500;
  }

  &--success {
    background: $primary-50;
    color:      $success;
  }

  &--warning {
    background: $yellow-50;
    color:      $yellow-600;
  }

  &--danger {
    background: $red-50;
    color:      $danger;
  }

  &--secondary {
    background: $gray-100;
    color:      $dark;
  }
}
</style>